import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Decrypt } from '../../pages/functions/functions';
import { Observable } from 'rxjs';



const base_url  = environment.api;

@Injectable({
  providedIn: 'root'
})
export class MailService {

  constructor(private http:HttpClient) { }
  get token(): string {
    return localStorage.getItem('token') || '';
  }

  get iduser(): string {
    let data = localStorage.getItem('key_id') || ''
    return  data ? Decrypt(data) : '';
  }
  get headers() {
    return {
      headers: {
        'x-token': this.token
      }
    }
  }
    sendmail(mail:any){
      return this.http.get(`${base_url}sendmail/${mail}`,this.headers);
    }


    validateToken(token:any){
      return this.http.get(`${base_url}valid/${token}`,this.headers)
    }
    // archivos mensualer


  getGenerateMensual(
  mes: any,
  force = false,
  confirmedProductId: number | null = null
) {

  let url =
    `${base_url}generar_mensual/${mes}/${this.iduser}?force=${force}`;

  if (confirmedProductId !== null) {
    url += `&confirmedProductId=${confirmedProductId}`;
  }

  return this.http.get(url, this.headers);
}

  

getAllCfdi(
  page: number,
  limit: number,
  filtro: string = ''
) {

  const params = {
    page: page.toString(),
    limit: limit.toString(),
    filtro: filtro
  };

  return this.http.get(
    `${base_url}allcfdi`,
    {
      ...this.headers,
      params: params
    }
  );

}

    reversarJson(data:any){
      return this.http.put(`${base_url}reversar_json_mensual/${data.id}`,this.headers);
    }
    getValidateCFDIDiario(fecha:any){
      return this.http.get(`${base_url}validar_file_diario/${fecha}`,this.headers);

    }

    getGenerateDiario(mes:any){
      return this.http.get(`${base_url}generar_diario/${mes}/${this.iduser}`,this.headers);
    }

    getAllCfdiDiario(){
      return this.http.get(`${base_url}allcfdiDiario`,this.headers);

    }

    caragaDocumetosSat(data:any,id_acep:any){
      return this.http.post(`${base_url}uploadinfoattachment/${id_acep}`,data,this.headers);
    }
    getDocumetosSat(id_acep:any){
      return this.http.get(`${base_url}uploadinfoattachment/${id_acep}`,this.headers);
    }
    donwloadDocumetn(name:any){
      return this.http.get(`${base_url}download_attachment/${name}`,{headers:{'x-token': this.token}, responseType:'blob'});
    }
    downloadXMLFiles({id,name}:any){
      return this.http.get(`${base_url}xmlDownloadFile/${name}/${id}`,{headers:{'x-token': this.token}, responseType:'blob'});
    }
    convertCfdi(id:any){
      return this.http.get(`${base_url}convertcfdi/${id}`,this.headers);
    }

    downloadExcel(id:any): Observable<Blob> {
      return this.http.get(`${base_url}mensual/convertsion/${id}`, {
        headers:{'x-token': this.token},
        responseType: 'blob'
      });
    }
}
